import { Component, Input, OnInit } from '@angular/core';

import { MainFacade } from '../../main.facade';
import { MainUtilities } from '../../main.utilities';
import { Observable } from 'rxjs';

@Component({
  selector: 'code-panel',
  templateUrl: './code.component.html',
  styleUrls: ['./code.component.scss'],
})
export class CodeComponent implements OnInit {

  // Extensions with a highlighter. ImageJ macros (.ijm) are C-like, and highlight.js has no
  // ImageJ grammar, so they use its JavaScript one. Anything not listed (.txt, .log, ...) is shown
  // as plain text rather than auto-detected, which mislabels prose as code.
  private static readonly LANGUAGE_BY_EXTENSION: Record<string, string> = {
    groovy: 'groovy',
    ijm: 'javascript',
    json: 'json',
    geojson: 'json',
    xml: 'xml',
  };
  /** Longer files are cut here - highlighting (and rendering) megabytes of text freezes the page. */
  static readonly MAX_CHARS = 1_000_000;

  content = '';
  isBinary = false;
  truncated = false;
  isLoading$!: Observable<boolean>;

  // Restricts detection to the one language of a recognized extension, since a short or
  // ambiguous script could otherwise be misdetected as something else. Empty means plain text.
  highlightLanguages: string[] = [];

  constructor(private mainFacade: MainFacade) {
  }

  ngOnInit(): void {
    this.isLoading$ = this.mainFacade.getFileLoading$();

    this.mainFacade.getSelectedNode$().subscribe({
      next: (node) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const extension = (node?.data as any)?.fileExtension as string | undefined;
        const language = extension ? CodeComponent.LANGUAGE_BY_EXTENSION[extension.toLowerCase()] : undefined;
        this.highlightLanguages = language ? [language] : [];
      },
    });

    this.mainFacade.getFileContent$().subscribe({
      next: (data:string | null) => {
        this.isBinary = data !== null && MainUtilities.looksBinary(data);
        this.truncated = !this.isBinary && data !== null && data.length > CodeComponent.MAX_CHARS;
        this.content = data === null || this.isBinary ? ''
          : this.truncated ? data.substring(0, CodeComponent.MAX_CHARS) : data;
      }
    });
  }
}
